import { useIntl } from 'react-intl';
import { Button, Dialog, Flexbox, Spacer, Spacings } from '@skf-internal/ui-components-react-legacy';
import GeneratorForm from '../form/GeneratorForm';
import { RelationGenerator } from 'domain/index';

const GeneratorDialog = ({ generatorToEdit, isOpen, onFormChange, onSave, onCancel, formError }: Props) => {
  const intl = useIntl();
  const saveIsDisabled = (): boolean => (formError ? formError?.size > 0 : false);

  return (
    <>
      <Dialog cssWidth={'40rem'} cssHeight={'31rem'} feInterruptive feTitle={!!generatorToEdit.objectId ? intl.formatMessage({ id: 'generator.form.edit' }) : intl.formatMessage({ id: 'generator.form.add' })} open={isOpen}>
        <GeneratorForm
          generator={generatorToEdit}
          onFormChange={(value: RelationGenerator) => {
            onFormChange(value);
          }}
          formError={formError}
        />
        <Spacer />
        <Flexbox feGap={Spacings.Md} feJustifyContent="flex-end">
          <Button feType="secondary" onClick={onCancel}>
            {intl.formatMessage({ id: 'windTurbine.form.cancel' })}
          </Button>
          <Button onClick={onSave} disabled={false}>
            {intl.formatMessage({ id: 'windTurbine.form.save' })}
          </Button>
        </Flexbox>
      </Dialog>
    </>
  );
};

interface Props {
  generatorToEdit: RelationGenerator;
  isOpen: boolean;
  onFormChange: any;
  onSave: any;
  onCancel: any;
  formError?: Map<string, string>;
}

export default GeneratorDialog;
